export default import.meta.ROLLUP_FILE_URL_CjFJ91mBigbMvM3tJnD3OQ